import { useEffect } from 'react';
import { useTour } from './TourProvider';

/**
 * Register a page with the tour engine. The page's tour starts by itself the
 * first time this user opens it (or when another tour handed over to it), and
 * the Help (?) menu's "Replay this page's tour" replays it.
 *
 *   usePageTour('dashboard', ready)   // ready: wait until the page has its data
 */
export function usePageTour(pageKey, ready = true) {
  const { ready: userReady, maybeStart, leavePage } = useTour();
  useEffect(() => {
    if (!ready || !userReady) return undefined;
    const cancel = maybeStart(pageKey);
    return () => { cancel(); leavePage(pageKey); };
  }, [pageKey, ready, userReady, maybeStart, leavePage]);
}

export default usePageTour;
